module.exports = __webpack_public_path__ + "img/EMT-PRCA_10X_ANS.7e20f29b.png";